import classNames from 'classnames';
import { ElementType, FC, MutableRefObject, PropsWithChildren, ReactElement } from 'react';

import { IconView } from '@gem/ui-kit';

import styles from './MetaBlock.styles.m.css';

export type TMetaBlockSize = 'small-1' | 'small-2';

export interface IMetaBlockProps {
  className?: string;
  label: string | ReactElement;
  containerRef?: MutableRefObject<HTMLDivElement>;
  Icon?: ElementType;
  Actions?: ReactElement;
  size?: TMetaBlockSize;
  onClick?(): void;
}

export const MetaBlock: FC<PropsWithChildren<IMetaBlockProps>> = ({
  className,
  label,
  children,
  containerRef,
  Icon,
  Actions,
  size = 'small-1',
  onClick,
}) => {
  const containerClassName = classNames(styles.container, className, styles[`${size}-size`]);

  return (
    <div
      {...(onClick ? { role: 'button', tabIndex: 0 } : {})}
      onClick={onClick}
      className={containerClassName}
      ref={containerRef}
    >
      {Icon && (
        <IconView
          className={styles.icon}
          Icon={Icon}
        />
      )}
      <div className={styles.info}>
        <h6 className={styles.label}>{label}</h6>
        <div className={styles.content}>{children}</div>
      </div>
      {Actions && (
        <div className={styles.actions}>
          <div className={styles.shadow} />
          <div className={styles.actionsBackground}>{Actions}</div>
        </div>
      )}
    </div>
  );
};
